import _ from 'lodash';
import { createSelector } from 'reselect';

import { StoreState } from '../../../redux/reducers/store.types';
import { getProjectTeamMembers } from '../../team/team-members-list/team-members-list.selectors';
import { getSecurityGroupsByMember } from '../../team/team.selectors-ui';
import { TeamMember } from '../../team/team.types';

import { ProjectOverviewMembersUiState } from './project-overview-members.reducer-ui';

const projectOverviewMembersUiState = (
  state: StoreState,
): ProjectOverviewMembersUiState =>
  state.projectOverviewState.projectOverviewMembersUiState;

export const isProjectOverviewMembersAddMemberModalOpened = createSelector(
  projectOverviewMembersUiState,
  (state: ProjectOverviewMembersUiState): boolean =>
    state.isMemberAddModalOpened,
);

export const isProjectOverviewMembersDeleteMemberModalOpened = createSelector(
  projectOverviewMembersUiState,
  (state: ProjectOverviewMembersUiState): boolean =>
    state.isMemberDeleteModalOpened,
);

export const isProjectOverviewMembersEditMemberModalOpened = createSelector(
  projectOverviewMembersUiState,
  (state: ProjectOverviewMembersUiState): boolean =>
    state.isMemberEditModalOpened,
);

export const isProjectOverviewMembersListModalOpened = createSelector(
  projectOverviewMembersUiState,
  (state: ProjectOverviewMembersUiState): boolean =>
    state.isMembersListModalOpened,
);

export const getProjectOverviewMembersDeletingMemberId = createSelector(
  projectOverviewMembersUiState,
  (state: ProjectOverviewMembersUiState): string | undefined =>
    state.deletingMemberId,
);

export const getProjectOverviewMembersDeletingMember = createSelector(
  getProjectTeamMembers,
  getProjectOverviewMembersDeletingMemberId,
  (
    members: TeamMember[],
    memberId: string | undefined,
  ): TeamMember | undefined => _.find(members, { id: memberId }),
);

export const getProjectOverviewMembersEditingMemberId = createSelector(
  projectOverviewMembersUiState,
  (state: ProjectOverviewMembersUiState): string | undefined =>
    state.editingMemberId,
);

const getProjectOverviewMembersEditingMember = createSelector(
  getProjectTeamMembers,
  getProjectOverviewMembersEditingMemberId,
  (
    members: TeamMember[],
    memberId: string | undefined,
  ): TeamMember | undefined => _.find(members, { id: memberId }),
);

export const getProjectOverviewMembersEditingMemberAvatarUrl = createSelector(
  getProjectOverviewMembersEditingMember,
  (editingMember: TeamMember | undefined): string =>
    _.get(editingMember, 'avatarUrl', ''),
);

export const getProjectOverviewMembersEditingMemberEmail = createSelector(
  getProjectOverviewMembersEditingMember,
  (editingMember: TeamMember | undefined): string =>
    _.get(editingMember, 'primaryEmail.address', ''),
);

export const getProjectOverviewMembersEditingName = createSelector(
  getProjectOverviewMembersEditingMember,
  (editingMember: TeamMember | undefined): string =>
    _.get(editingMember, 'name', ''),
);

export const getProjectOverviewMembersEditingSecurityGroups = createSelector(
  getProjectOverviewMembersEditingMember,
  getSecurityGroupsByMember,
);
